import { Select } from '@bambi/component-library/src/components/inputs/Select/Select';
import { SelectOption } from '@bambi/component-library/src/components/inputs/Select/SelectOption/SelectOption';

import { AssignmentSorting } from 'src/features/dispatch/constants';

import { useDispatchAssignmentSort } from './useDispatchAssignmentSort';

const sortingOptions: SelectOption<AssignmentSorting>[] = [
  {
    label: 'Driver Name',
    value: AssignmentSorting.DRIVER_NAME,
  },
  {
    label: 'End Time',
    value: AssignmentSorting.END_TIME,
  },
  {
    label: 'Start Time',
    value: AssignmentSorting.START_TIME,
  },
  {
    label: 'Vehicle Name',
    value: AssignmentSorting.VEHICLE_NAME,
  },
];

export function AssignmentSortSelect() {
  const { assignmentSorting, setAssignmentSortingState } =
    useDispatchAssignmentSort();

  return (
    <div className="flex w-full flex-col gap-2">
      <div className="text-xs font-medium">Assignment Sort</div>
      <div className="w-full">
        <Select
          testIdSuffix="dispatch-assignment-sort"
          value={assignmentSorting}
          options={sortingOptions}
          onChange={(option) =>
            setAssignmentSortingState(
              // this is failing in CI even though the option could be undefined
              /* eslint-disable @typescript-eslint/no-unnecessary-condition */
              (option?.value as AssignmentSorting) ||
                AssignmentSorting.START_TIME
            )
          }
        />
      </div>
    </div>
  );
}
